export default __webpack_public_path__ + "static/media/voting.94553a58.png";